import React, { useMemo } from 'react';
import InsightCard from './InsightCard';
import { buildInsightGroups } from '../insightModel';

/**
 * Блок attention / positive_signals, карточки сгруппированы по insight.group.
 * children — группа повторяющихся нарушений (RepeatedPatterns), стоит первой.
 */
const InsightsSection = ({
  title, items, severityKind, cameraNames, emptyText, extraCount = 0, children,
}) => {
  const groups = useMemo(
    () => buildInsightGroups(items, severityKind, cameraNames),
    [items, severityKind, cameraNames]
  );
  const isEmpty = groups.length === 0 && extraCount === 0;
  return (
    <section className="sum-card">
      <h2 className="sum-card-title">{title}</h2>
      {isEmpty ? <p className="sum-muted">{emptyText}</p> : (
        <>
          {children}
          {groups.map((group) => (
            <div className="sum-insight-group" key={group.group}>
              <h3 className="sum-insight-group-title">{group.title}</h3>
              <div className="sum-insights">
                {group.cards.map((card, index) => (
                  <InsightCard key={`${card.code}-${index}`} card={card} />
                ))}
              </div>
            </div>
          ))}
        </>
      )}
    </section>
  );
};

export default InsightsSection;
